export default function oneOfType (possibleCheckers, ...args) {
  let checker = (obj, key, cname, location, fullName) => {
    for (let possibleChecker of possibleCheckers) {
      let check = possibleChecker(obj, key, cname, location, fullName);
      if (!check) {
        return; // only one has to pass
      }
    }
    // nothing passed, so we failed
    return new TypeError(`Value at ${fullName} is must pass one of the following checkers: ${possibleCheckers.map(c => c.checkerName).join(' or ')}`);

  };
  checker.checkerName = 'oneOfType';
  {
    let validChecker = false;
    for (let possibleChecker of possibleCheckers) {
      if (typeof checker.makeNew === 'function') {
        if (validChecker) {
          throw new Error('Only one of the oneOfType checkers can define getCheckerForKey() (which one would we call?)');
        } else {
          validChecker = possibleChecker;
        }
      }
    }
    if (validChecker) {
      checker.getCheckerForKey = (...keyArgs) => validChecker.getCheckerForKey(...keyArgs);
    }
  }

  {
    let validChecker = false;
    for (let possibleChecker of possibleCheckers) {
      if (typeof possibleChecker.makeNew === 'function') {
        if (validChecker) {
          throw new Error('Only one of the oneOfType checkers can define makeNew() (which one would we call?)');
        } else {
          validChecker = possibleChecker;
        }
      }
    }
    if (validChecker) {
      checker.makeNew = () => validChecker.makeNew();
    }
  }
  if (args.length > 0) {
    throw new Error(`Extraneous arguments to ${checker.checkerName}`);
  }
  if (!Array.isArray(possibleCheckers)) {
    throw new Error(`Invalid argument type to ${checker.checkerName}: ${possibleCheckers}`);
  }
  for (let [key, possibleChecker] of possibleCheckers.entries()) {
    if (typeof possibleChecker !== 'function') {
      throw new Error(`Invalid checker at ${key} for ${checker.checkerName}`);
    }
    if (!checker.checkerName) {
      throw new Error(`Non-rlink-shape checker at ${key} for ${checker.checkerName}. Are you trying to mix shapes and PropTypes? (this is not supported)`);
    }
  }
  return checker;
}





// WEBPACK FOOTER //
// ./lib/rlink-shapes/oneOfType.js